export default __webpack_public_path__ + "static/media/411.4b3c7002.png";